"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailSendRequestStatus = exports.EmailSendContentItem = exports.EmailSendModel = exports.SendGridEmailTemplateVersion = exports.SendGridEmailTemplate = exports.CampaignModel = exports.OpportunityProductModel = exports.SalesIncentiveOpportunityFileModel = exports.SalesIncentiveOpportunityModel = exports.SalesIncentiveOpportunityInputModel = exports.EntityPrequisiteModel = exports.TeamModel = exports.AllocatedReward = exports.RewardModel = exports.ContentTemplateModel = exports.FeedItemModel = exports.TeamMemberStatusModel = exports.ApplicationProfileFieldModel = exports.ApplicationProfileModel = exports.UserPreferencesModel = exports.UpdateUserModel = exports.UserModel = exports.UserStatusModel = exports.TeamStatusModel = exports.AssetModel = exports.EmailTemplateParam = exports.EmailSendDataModel = exports.InteractionDataModel = exports.EmailExportModel = exports.UserQuestionDataModel = exports.TrainingEpisodeResponseDataModel = exports.UserDataModel = exports.TrainingEpisodeQuestionDataModel = exports.TrainingEpisodeDataModel = exports.TrainingEpisodeModel = exports.AudienceModel = exports.LeaderboardModel = exports.KeyValueItem = exports.HintModel = exports.ZoneStateModel = exports.ZoneModel = exports.BirdseyeZoneModel = exports.OutroContentModel = exports.AnswerModel = exports.ContentUriModel = exports.QuestionModel = exports.SectionModel = exports.DetailsModel = exports.QuizModel = exports.AccessToken = void 0;
exports.EmailTemplateTypeEnum = exports.EntityPrequisiteType = exports.RewardLevel = exports.AudienceType = exports.EmailSendStatusType = exports.InteractionEventType = exports.ContentUriType = exports.RewardType = exports.TrainingContentType = exports.TrainingQuestionType = exports.ProfileFieldType = exports.FeedDisplayType = exports.ContentType = exports.CampaignType = exports.FormatType = exports.OpportunityStatus = exports.OpportunityType = void 0;
var AccessToken = /** @class */ (function () {
    function AccessToken(accessToken, refreshToken, idToken, expiresParsed, expiresIn) {
        this.access_token = accessToken;
        this.refresh_token = refreshToken;
        this.id_token = idToken;
        this.expires_ticks = expiresParsed;
        this.expires_in = expiresIn;
    }
    return AccessToken;
}());
exports.AccessToken = AccessToken;
var QuizModel = /** @class */ (function () {
    function QuizModel(identifier, title, summary, details, sections, questions, outroContent, isComplete) {
        this.identifier = identifier;
        this.title = title;
        this.summary = summary;
        this.details = details;
        this.sections = sections;
        this.questions = questions;
        this.outroContent = outroContent;
        this.isComplete = isComplete;
    }
    return QuizModel;
}());
exports.QuizModel = QuizModel;
var DetailsModel = /** @class */ (function () {
    function DetailsModel() {
        this.firstName = "";
        this.lastName = "";
        this.businessEmail = "";
        this.telephoneNumber = "";
        this.jobTitle = "";
        this.employeeCount = "";
        this.companyName = "";
        this.contactConsent = false;
        this.agreeRules = false;
        this.upload = null;
    }
    return DetailsModel;
}());
exports.DetailsModel = DetailsModel;
var SectionModel = /** @class */ (function () {
    function SectionModel(order, title, summary, questions) {
        this.key = order;
        this.title = title;
        this.summary = summary;
        this.questions = questions;
    }
    return SectionModel;
}());
exports.SectionModel = SectionModel;
var QuestionModel = /** @class */ (function () {
    function QuestionModel(number, question, trainingQuestionType, contentUris, answers, allowOther, answered, correctAnswerText) {
        this.number = number;
        this.question = question;
        this.answers = answers;
        this.trainingQuestionType = trainingQuestionType;
        this.contentUris = contentUris;
        this.correctAnswerText = correctAnswerText;
        //this.score = score;
        //this.userAnswer = userAnswer;
        //this.userAnswerIndex = userAnswerIndex;
        //this.userAnswerIndexes = userAnswerIndexes;
        this.allowOther = allowOther;
        this.displayOther = false;
        this.answered = answered;
    }
    return QuestionModel;
}());
exports.QuestionModel = QuestionModel;
var ContentUriModel = /** @class */ (function () {
    function ContentUriModel(identifier, uri, type) {
        this.identifier = identifier;
        this.uri = uri;
        this.type = type;
    }
    return ContentUriModel;
}());
exports.ContentUriModel = ContentUriModel;
var AnswerModel = /** @class */ (function () {
    function AnswerModel(number, text, isCorrect, userAnswer, score) {
        this.number = number;
        this.text = text;
        this.isCorrect = isCorrect;
        this.score = score;
        this.selected = false;
    }
    return AnswerModel;
}());
exports.AnswerModel = AnswerModel;
var OutroContentModel = /** @class */ (function () {
    function OutroContentModel(title, summary, closeButtonText) {
        this.title = title;
        this.summary = summary;
        this.closeButtonText = closeButtonText;
    }
    return OutroContentModel;
}());
exports.OutroContentModel = OutroContentModel;
var BirdseyeZoneModel = /** @class */ (function () {
    function BirdseyeZoneModel(id, coords) {
        this.id = id;
        this.coords = coords;
    }
    return BirdseyeZoneModel;
}());
exports.BirdseyeZoneModel = BirdseyeZoneModel;
var ZoneModel = /** @class */ (function () {
    function ZoneModel(id, zoneState) {
        this.id = id;
        this.zoneState = zoneState;
    }
    return ZoneModel;
}());
exports.ZoneModel = ZoneModel;
var ZoneStateModel = /** @class */ (function () {
    function ZoneStateModel(image, start, finish, quizId) {
        this.image = image;
        this.start = start;
        this.finish = finish;
        this.quizId = quizId;
        this.finishDisplay = "".concat(finish.getDate(), "/").concat(finish.getMonth() + 1, "/").concat(finish.getFullYear());
        this.closed = new Date() > finish;
    }
    return ZoneStateModel;
}());
exports.ZoneStateModel = ZoneStateModel;
var HintModel = /** @class */ (function () {
    function HintModel(coords, text) {
        this.coords = coords;
        this.text = text;
    }
    return HintModel;
}());
exports.HintModel = HintModel;
var KeyValueItem = /** @class */ (function () {
    function KeyValueItem(key, value) {
        this.key = key;
        this.value = value;
    }
    return KeyValueItem;
}());
exports.KeyValueItem = KeyValueItem;
var LeaderboardModel = /** @class */ (function () {
    function LeaderboardModel() {
        this.teamMembers = new Array();
    }
    return LeaderboardModel;
}());
exports.LeaderboardModel = LeaderboardModel;
var AudienceModel = /** @class */ (function () {
    function AudienceModel() {
        this.type = AudienceType.All;
        this.value = "";
    }
    return AudienceModel;
}());
exports.AudienceModel = AudienceModel;
var TrainingEpisodeModel = /** @class */ (function () {
    function TrainingEpisodeModel() {
        this.identifier = "";
        this.title = "";
        this.summary = "";
        this.questions = new Array();
        this.category = "";
        this.episodeNumber = 0;
        this.seasonNumber = 0;
        this.contentType = TrainingContentType.Other;
        this.contentUris = new Array();
        this.episodeCompletedText = "";
        this.dateStart = new Date();
        this.dateExpires = new Date();
        this.isComplete = false;
        this.audiences = new Array();
        this.entityPrerequisites = new Array();
    }
    return TrainingEpisodeModel;
}());
exports.TrainingEpisodeModel = TrainingEpisodeModel;
var TrainingEpisodeDataModel = /** @class */ (function () {
    function TrainingEpisodeDataModel() {
        this.trainingEpisodeIdentifier = "";
        this.questionData = new Array();
        this.dataBag = null;
    }
    return TrainingEpisodeDataModel;
}());
exports.TrainingEpisodeDataModel = TrainingEpisodeDataModel;
var TrainingEpisodeQuestionDataModel = /** @class */ (function () {
    function TrainingEpisodeQuestionDataModel(questionNumber, answerNumber, answerNumbers, answer, attempts) {
        this.questionNumber = questionNumber;
        this.answerNumber = answerNumber;
        this.answerNumbers = answerNumbers;
        this.answer = answer;
        this.attempts = attempts;
    }
    return TrainingEpisodeQuestionDataModel;
}());
exports.TrainingEpisodeQuestionDataModel = TrainingEpisodeQuestionDataModel;
var UserDataModel = /** @class */ (function () {
    function UserDataModel(user, episodeScore, questionData, winner, questions) {
        this.user = user;
        this.episodeScore = episodeScore;
        this.questionData = questionData;
        this.winner = winner;
        this.correctAnswerCount = 0;
        this.questionCount = questions.length;
        var answerCount = 0;
        questionData.map(function (userQuestion) {
            var quizQuestion = questions.filter(function (question) { return question.number == userQuestion.questionNumber; })[0];
            var quizCorrectAnswer = quizQuestion.answers.filter(function (question) { return question.isCorrect == true; })[0];
            if (userQuestion.answerNumber == quizCorrectAnswer.number) {
                answerCount++;
            }
        });
        this.correctAnswerCount = answerCount;
        this.eligible = (answerCount == questions.length);
    }
    return UserDataModel;
}());
exports.UserDataModel = UserDataModel;
var TrainingEpisodeResponseDataModel = /** @class */ (function () {
    function TrainingEpisodeResponseDataModel(episodeScore, maxScore, allocatedRewards) {
        if (allocatedRewards === void 0) { allocatedRewards = null; }
        this.episodeScore = episodeScore;
        this.maxScore = maxScore;
        this.allocatedRewards = allocatedRewards;
    }
    return TrainingEpisodeResponseDataModel;
}());
exports.TrainingEpisodeResponseDataModel = TrainingEpisodeResponseDataModel;
var UserQuestionDataModel = /** @class */ (function () {
    function UserQuestionDataModel(questionNumber, answerNumber, answerNumbers, answer, attempts) {
        this.questionNumber = questionNumber;
        this.answerNumber = answerNumber;
        this.answerNumbers = answerNumbers;
        this.answer = answer;
        this.attempts = attempts;
    }
    return UserQuestionDataModel;
}());
exports.UserQuestionDataModel = UserQuestionDataModel;
var EmailExportModel = /** @class */ (function () {
    function EmailExportModel(email) {
        this.email = email;
    }
    return EmailExportModel;
}());
exports.EmailExportModel = EmailExportModel;
var InteractionDataModel = /** @class */ (function () {
    function InteractionDataModel(eventType, eventIdentifier, eventValue, occurredOn, campaignIdentifier, clientIpAddress, score, tags, data) {
        if (data === void 0) { data = null; }
        this.eventType = eventType;
        this.eventIdentifier = eventIdentifier;
        this.eventValue = eventValue;
        this.campaignIdentifier = campaignIdentifier;
        this.clientIpAddress = clientIpAddress;
        this.score = score;
        this.tags = tags;
        this.data = data;
        this.formSubmissionEmailToAddresses = [];
    }
    return InteractionDataModel;
}());
exports.InteractionDataModel = InteractionDataModel;
var EmailSendDataModel = /** @class */ (function () {
    function EmailSendDataModel(identifier, templateId, templateName, recipientList, fromName, fromAddress, content) {
        this.identifier = identifier;
        this.templateId = templateId;
        this.templateName = templateName;
        this.recipientList = recipientList;
        this.fromName = fromName;
        this.fromAddress = fromAddress;
        this.content = content;
        this.emailSendRequestStatus = EmailSendStatusType.Approved;
    }
    return EmailSendDataModel;
}());
exports.EmailSendDataModel = EmailSendDataModel;
var EmailTemplateParam = /** @class */ (function () {
    function EmailTemplateParam(key, value) {
        this.key = key;
        this.value = value;
    }
    return EmailTemplateParam;
}());
exports.EmailTemplateParam = EmailTemplateParam;
var AssetModel = /** @class */ (function () {
    function AssetModel(name, type, fullUri, uri, description, thumbnail, tags, productFamily, productModel) {
        this.name = name;
        this.type = type;
        this.fullUri = fullUri;
        this.uri = uri;
        this.description = description;
        this.thumbnail = thumbnail;
        this.tags = tags;
        this.productFamily = productFamily;
        this.productModel = productModel;
    }
    return AssetModel;
}());
exports.AssetModel = AssetModel;
var TeamStatusModel = /** @class */ (function () {
    function TeamStatusModel(name, totalPoints, totalScore, teamMemberStatus) {
        this.name = name;
        this.totalPoints = totalPoints;
        this.totalScore = totalScore;
        this.teamMemberStatus = teamMemberStatus;
    }
    return TeamStatusModel;
}());
exports.TeamStatusModel = TeamStatusModel;
var UserStatusModel = /** @class */ (function () {
    function UserStatusModel(user, displayNameSafe, teamName, totalPoints, currentLevel, currentLevelPoints, nextLevelIn) {
        this.user = user;
        this.displayNameSafe = displayNameSafe;
        this.teamName = teamName;
        this.totalPoints = totalPoints;
        this.currentLevel = currentLevel;
        this.currentLevelPoints = currentLevelPoints;
        this.nextLevelIn = nextLevelIn;
    }
    return UserStatusModel;
}());
exports.UserStatusModel = UserStatusModel;
var UserModel = /** @class */ (function () {
    function UserModel() {
        this.userName = "";
        this.companyLocation = "";
        this.companyName = "";
        this.countryCode = "";
        this.dateOfBirth = new Date();
        this.email = "";
        this.emailConfirmed = false;
        this.firstName = "";
        this.displayName = "";
        this.displayNameSafe = "";
        this.jobFunction = "";
        this.jobspecialties = [];
        this.languagePreference = "";
        this.lastName = "";
        this.phoneNumber = "";
        this.profileData = new Array();
        this.teamAssignments = [];
    }
    return UserModel;
}());
exports.UserModel = UserModel;
var UpdateUserModel = /** @class */ (function () {
    function UpdateUserModel() {
        this.email = "";
        this.userName = "";
        this.displayName = "";
    }
    return UpdateUserModel;
}());
exports.UpdateUserModel = UpdateUserModel;
var UserPreferencesModel = /** @class */ (function () {
    function UserPreferencesModel() {
        this.user = "";
        this.additionalProfileFields = [];
        this.marketingConsent = false;
    }
    return UserPreferencesModel;
}());
exports.UserPreferencesModel = UserPreferencesModel;
var ApplicationProfileModel = /** @class */ (function () {
    function ApplicationProfileModel() {
        this.additionalProfileFields = new Array();
    }
    return ApplicationProfileModel;
}());
exports.ApplicationProfileModel = ApplicationProfileModel;
var ApplicationProfileFieldModel = /** @class */ (function () {
    function ApplicationProfileFieldModel() {
        this.name = "";
        this.allowOther = false;
        this.profileFieldType = ProfileFieldType.Text;
        this.values = [];
    }
    return ApplicationProfileFieldModel;
}());
exports.ApplicationProfileFieldModel = ApplicationProfileFieldModel;
var TeamMemberStatusModel = /** @class */ (function () {
    function TeamMemberStatusModel(displayName, totalDealRegistrationsValue, totalPoints, totalRewards, user, currentLevel) {
        this.displayName = displayName;
        this.totalDealRegistrationsValue = totalDealRegistrationsValue;
        this.totalPoints = totalPoints;
        this.totalRewards = totalRewards;
        this.user = user;
        this.currentLevel = currentLevel;
    }
    return TeamMemberStatusModel;
}());
exports.TeamMemberStatusModel = TeamMemberStatusModel;
var FeedItemModel = /** @class */ (function () {
    function FeedItemModel() {
        this.identifier = "";
        this.title = "";
        this.subTitle = "";
        this.type = FeedDisplayType.None;
        this.countryCode = "";
        this.contentUris = new Array();
        this.tags = new Array();
        this.languageCode = "";
        this.dateCreated = new Date();
        this.dateModified = new Date();
        this.dateExpires = new Date();
        this.datePublished = new Date();
        this.linkToIdentifier = null;
        this.actionUri = null;
        this.isArchived = false;
    }
    return FeedItemModel;
}());
exports.FeedItemModel = FeedItemModel;
var ContentTemplateModel = /** @class */ (function () {
    function ContentTemplateModel() {
        this.identifier = "";
        this.summary = "";
        this.subTitle = "";
        this.title = "";
        this.template = "";
        this.author = "";
        this.type = ContentType.Static;
        this.countryCode = "";
        this.contentUris = new Array();
        this.tags = new Array();
        this.languageCode = "";
        this.dateCreated = new Date();
        this.dateModified = new Date();
        this.dateExpires = new Date();
        this.isArchived = false;
        this.isShareable = false;
        this.timeToRead = 0;
    }
    return ContentTemplateModel;
}());
exports.ContentTemplateModel = ContentTemplateModel;
var RewardModel = /** @class */ (function () {
    function RewardModel() {
        this.identifier = "";
        this.rewardType = RewardType.Badge;
        this.rewardValue = 0;
        this.imageUri = "";
        this.title = "";
        this.description = "";
        this.eventType = InteractionEventType.AppArticleRequest;
        this.requiredFrequency = 0;
        this.level = RewardLevel.None;
        this.userAwarded = false;
    }
    return RewardModel;
}());
exports.RewardModel = RewardModel;
var AllocatedReward = /** @class */ (function () {
    function AllocatedReward() {
        this.identifier = "";
        this.rewardId = "";
        this.rewardType = RewardType.Badge;
    }
    return AllocatedReward;
}());
exports.AllocatedReward = AllocatedReward;
var TeamModel = /** @class */ (function () {
    function TeamModel(identifier, emailSuffixList, division, locations, longName, name, profileData) {
        this.identifier = identifier;
        this.emailSuffixList = emailSuffixList;
        this.division = division;
        this.locations = locations;
        this.longName = longName;
        this.name = name;
        this.profileData = profileData;
    }
    return TeamModel;
}());
exports.TeamModel = TeamModel;
var EntityPrequisiteModel = /** @class */ (function () {
    function EntityPrequisiteModel() {
        this.entityPrequisiteType = EntityPrequisiteType.Interaction;
        this.eventType = "";
        this.eventIdentifier = "";
        this.eventValue = "";
        this.isSatisfied = false;
    }
    return EntityPrequisiteModel;
}());
exports.EntityPrequisiteModel = EntityPrequisiteModel;
var SalesIncentiveOpportunityInputModel = /** @class */ (function () {
    function SalesIncentiveOpportunityInputModel() {
        this.opportunityId = null;
        this.campaignIdentifier = "";
        this.oem = "";
        this.details = "";
        this.customerName = "";
        this.dateCreated = new Date();
        this.opportunityCode = "";
        this.opportunityDate = new Date();
        this.type = OpportunityType.Deal;
        this.status = OpportunityStatus.Open;
        this.user = "";
        this.value = 0;
        this.products = new Array();
    }
    return SalesIncentiveOpportunityInputModel;
}());
exports.SalesIncentiveOpportunityInputModel = SalesIncentiveOpportunityInputModel;
var SalesIncentiveOpportunityModel = /** @class */ (function () {
    function SalesIncentiveOpportunityModel() {
        this.opportunityId = null;
        this.campaignIdentifier = "";
        this.oem = "";
        this.details = "";
        this.customerName = "";
        this.dateCreated = new Date();
        this.opportunityCode = "";
        this.opportunityDate = new Date();
        this.type = OpportunityType.Deal;
        this.status = OpportunityStatus.Open;
        this.user = "";
        this.value = 0;
        this.products = new Array();
        this.files = new Array();
    }
    return SalesIncentiveOpportunityModel;
}());
exports.SalesIncentiveOpportunityModel = SalesIncentiveOpportunityModel;
var SalesIncentiveOpportunityFileModel = /** @class */ (function () {
    function SalesIncentiveOpportunityFileModel() {
        this.fileName = null;
        this.fileUri = null;
    }
    return SalesIncentiveOpportunityFileModel;
}());
exports.SalesIncentiveOpportunityFileModel = SalesIncentiveOpportunityFileModel;
var OpportunityProductModel = /** @class */ (function () {
    function OpportunityProductModel(description, productSku, quantity) {
        this.description = description;
        this.productSku = productSku;
        this.quantity = quantity;
    }
    return OpportunityProductModel;
}());
exports.OpportunityProductModel = OpportunityProductModel;
var CampaignModel = /** @class */ (function () {
    function CampaignModel() {
        this.identifier = null;
        this.languageCode = null;
        this.countryCode = null;
        this.title = null;
        this.subTitle = null;
        this.summary = null;
        this.template = null;
        this.templateFormatType = FormatType.Html;
        this.type = CampaignType.Programme;
        this.contentUris = new Array();
        this.dateStart = null;
        this.dateExpires = null;
        this.metaData = [];
    }
    return CampaignModel;
}());
exports.CampaignModel = CampaignModel;
var SendGridEmailTemplate = /** @class */ (function () {
    function SendGridEmailTemplate() {
        this.type = EmailTemplateTypeEnum.Default;
        this.senderAddress = "";
        this.sender = "";
        this.templateId = "";
        this.version = new Array();
    }
    return SendGridEmailTemplate;
}());
exports.SendGridEmailTemplate = SendGridEmailTemplate;
var SendGridEmailTemplateVersion = /** @class */ (function () {
    function SendGridEmailTemplateVersion() {
        this.id = "";
        this.name = "";
        this.htmlContent = "";
        this.thumbnailUrl = "";
    }
    return SendGridEmailTemplateVersion;
}());
exports.SendGridEmailTemplateVersion = SendGridEmailTemplateVersion;
var EmailSendModel = /** @class */ (function () {
    function EmailSendModel() {
        this.identifier = "";
        this.templateId = "";
        this.templateName = "";
        this.name = "";
        this.fromAddress = "";
        this.fromName = "";
        this.singleRecipient = "";
        this.content = new Array();
        this.recipientList = new Array();
        this.emailSendRequestStatus = EmailSendRequestStatus.Draft;
        this.approvedOn = null;
        this.approvedBy = "";
        this.createdBy = "";
        this.modifiedBy = "";
    }
    return EmailSendModel;
}());
exports.EmailSendModel = EmailSendModel;
var EmailSendContentItem = /** @class */ (function () {
    function EmailSendContentItem() {
        this.key = "";
        this.value = "";
    }
    return EmailSendContentItem;
}());
exports.EmailSendContentItem = EmailSendContentItem;
var EmailSendRequestStatus;
(function (EmailSendRequestStatus) {
    EmailSendRequestStatus["Draft"] = "DRAFT";
    EmailSendRequestStatus["Pending"] = "PENDING";
    EmailSendRequestStatus["Approved"] = "APPROVED";
    EmailSendRequestStatus["Rejected"] = "REJECTED";
})(EmailSendRequestStatus = exports.EmailSendRequestStatus || (exports.EmailSendRequestStatus = {}));
var OpportunityType;
(function (OpportunityType) {
    OpportunityType["Deal"] = "DEAL";
    OpportunityType["Opportunity"] = "OPPORTUNITY";
    OpportunityType["Sale"] = "SALE";
    OpportunityType["Reward"] = "REWARD";
})(OpportunityType = exports.OpportunityType || (exports.OpportunityType = {}));
var OpportunityStatus;
(function (OpportunityStatus) {
    OpportunityStatus["Open"] = "OPEN";
    OpportunityStatus["Won"] = "WON";
    OpportunityStatus["Lost"] = "LOST";
    OpportunityStatus["Queried"] = "QUERIED";
    OpportunityStatus["Rejected"] = "REJECTED";
    OpportunityStatus["Paid"] = "PAID";
    OpportunityStatus["Closed"] = "CLOSED";
})(OpportunityStatus = exports.OpportunityStatus || (exports.OpportunityStatus = {}));
var FormatType;
(function (FormatType) {
    FormatType["String"] = "STRING";
    FormatType["Markdown"] = "MARKDOWN";
    FormatType["Html"] = "HTML";
    FormatType["Other"] = "OTHER";
})(FormatType = exports.FormatType || (exports.FormatType = {}));
var CampaignType;
(function (CampaignType) {
    CampaignType["Programme"] = "PROGRAMME";
    CampaignType["Reward"] = "REWARD";
})(CampaignType = exports.CampaignType || (exports.CampaignType = {}));
var ContentType;
(function (ContentType) {
    ContentType["Static"] = "STATIC";
    ContentType["News"] = "NEWS";
    ContentType["Event"] = "EVENT";
    ContentType["Promotion"] = "PROMOTION";
    ContentType["Blog"] = "BLOG";
    ContentType["Portfolio"] = "PORTFOLIO";
    ContentType["Article"] = "ARTICLE";
    ContentType["Intro"] = "INTRO";
    ContentType["TermsAndConditions"] = "TERMS_AND_CONDITIONS";
    ContentType["Rules"] = "RULES";
    ContentType["PrivacyPolicy"] = "PRIVACY_POLICY";
    ContentType["Playbook"] = "PLAYBOOK";
    ContentType["ExternalLink"] = "EXTERNAL_LINK";
    ContentType["Video"] = "VIDEO";
    ContentType["YouTubeEmbed"] = "YOU_TUBE_EMBED";
    ContentType["VimeoEmbed"] = "VIMEO_EMBED";
})(ContentType = exports.ContentType || (exports.ContentType = {}));
var FeedDisplayType;
(function (FeedDisplayType) {
    FeedDisplayType["None"] = "NONE";
    FeedDisplayType["Hero"] = "HERO";
    FeedDisplayType["Primary"] = "PRIMARY";
    FeedDisplayType["Secondary"] = "SECONDARY";
    FeedDisplayType["Notification"] = "NOTIFICATION";
    FeedDisplayType["Reward"] = "REWARD";
    FeedDisplayType["TrainingEpisode"] = "TRAINING_EPISODE";
    FeedDisplayType["Video"] = "VIDEO";
})(FeedDisplayType = exports.FeedDisplayType || (exports.FeedDisplayType = {}));
var ProfileFieldType;
(function (ProfileFieldType) {
    ProfileFieldType["Text"] = "TEXT";
    ProfileFieldType["MultiChoice"] = "MULTI_CHOICE";
})(ProfileFieldType = exports.ProfileFieldType || (exports.ProfileFieldType = {}));
var TrainingQuestionType;
(function (TrainingQuestionType) {
    TrainingQuestionType["SingleChoice"] = "SINGLE_CHOICE";
    TrainingQuestionType["MultipleChoice"] = "MULTIPLE_CHOICE";
    TrainingQuestionType["FreeText"] = "FREE_TEXT";
})(TrainingQuestionType = exports.TrainingQuestionType || (exports.TrainingQuestionType = {}));
var TrainingContentType;
(function (TrainingContentType) {
    TrainingContentType["Video"] = "VIDEO";
    TrainingContentType["Image"] = "IMAGE";
    TrainingContentType["Document"] = "DOCUMENT";
    TrainingContentType["Other"] = "OTHER";
})(TrainingContentType = exports.TrainingContentType || (exports.TrainingContentType = {}));
var RewardType;
(function (RewardType) {
    RewardType["Badge"] = "BADGE";
    RewardType["Points"] = "POINTS";
    RewardType["PrizeDrawEntry"] = "PRIZE_DRAW_ENTRY";
    RewardType["Reward"] = "REWARD";
    RewardType["DealRegistrationReward"] = "DEAL_REGISTRATION_REWARD";
    RewardType["Voucher"] = "VOUCHER";
    RewardType["Experience"] = "EXPERIENCE";
    RewardType["OpportunityReward"] = "OPPORTUNITY_REWARD";
    RewardType["Level"] = "LEVEL";
    RewardType["InstantWin"] = "INSTANT_WIN";
})(RewardType = exports.RewardType || (exports.RewardType = {}));
var ContentUriType;
(function (ContentUriType) {
    ContentUriType["Video"] = "VIDEO";
    ContentUriType["Image"] = "IMAGE";
    ContentUriType["FeedImage"] = "FEED_IMAGE";
    ContentUriType["ThumbnailWide"] = "THUMBNAIL_WIDE";
    ContentUriType["ThumbnailTall"] = "THUMBNAIL_TALL";
    ContentUriType["Document"] = "DOCUMENT";
    ContentUriType["TrainingEpisodeVideo"] = "TRAINING_EPISODE_VIDEO";
    ContentUriType["Stylesheet"] = "STYLESHEET";
    ContentUriType["JavaScript"] = "JAVA_SCRIPT";
    ContentUriType["Other"] = "OTHER";
    ContentUriType["Badge"] = "BADGE";
    ContentUriType["LiveStream"] = "LIVE_STREAM";
    ContentUriType["WebLink"] = "WEB_LINK";
    ContentUriType["TermsAndConditions"] = "TERMS_AND_CONDITIONS";
    ContentUriType["PrivacyPolicy"] = "PRIVACY_POLICY";
    ContentUriType["YouTubeEmbed"] = "YOU_TUBE_EMBED";
    ContentUriType["VideoEmbed"] = "VIMEO_EMBED";
})(ContentUriType = exports.ContentUriType || (exports.ContentUriType = {}));
var InteractionEventType;
(function (InteractionEventType) {
    InteractionEventType["WebSessionStart"] = "WEB_SESSION_START";
    InteractionEventType["WebSessionEnd"] = "WEB_SESSION_END";
    InteractionEventType["WebPageView"] = "WEB_PAGE_VIEW";
    InteractionEventType["WebPageVisible"] = "WEB_PAGE_VISIBLE";
    InteractionEventType["WebPageScroll"] = "WEB_PAGE_SCROLL";
    InteractionEventType["WebClick"] = "WEB_CLICK";
    InteractionEventType["WebFormSubmit"] = "WEB_FORM_SUBMIT";
    InteractionEventType["WebFormDataInput"] = "WEB_FORM_DATA_INPUT";
    InteractionEventType["WebFormValidation"] = "WEB_FORM_VALIDATION";
    InteractionEventType["WebDownload"] = "WEB_DOWNLOAD";
    InteractionEventType["WebExternalLink"] = "WEB_EXTERNAL_LINK";
    InteractionEventType["WebVideoPlay"] = "WEB_VIDEO_PLAY";
    InteractionEventType["WebVideoPause"] = "WEB_VIDEO_PAUSE";
    InteractionEventType["WebVideoComplete"] = "WEB_VIDEO_COMPLETE";
    InteractionEventType["WebSearch"] = "WEB_SEARCH";
    InteractionEventType["WebError"] = "WEB_ERROR";
    InteractionEventType["WebModalOpen"] = "WEB_MODAL_OPEN";
    InteractionEventType["WebModalClose"] = "WEB_MODEL_CLOSE";
    InteractionEventType["EmailOpen"] = "EMAIL_OPEN";
    InteractionEventType["EmailClick"] = "EMAIL_CLICK";
    InteractionEventType["AppOpen"] = "APP_OPEN";
    InteractionEventType["AppClose"] = "APP_CLOSE";
    InteractionEventType["AppVideoPlay"] = "APP_VIDEO_PLAY";
    InteractionEventType["AppArticleView"] = "APP_ARTICLE_VIEW";
    InteractionEventType["AppShare"] = "APP_SHARE";
    InteractionEventType["AppDownload"] = "APP_DOWNLOAD";
    InteractionEventType["AppInvite"] = "APP_INVITE";
    InteractionEventType["AppVote"] = "APP_VOTE";
    InteractionEventType["AppArticleRequest"] = "APP_ARTICLE_REQUEST";
    InteractionEventType["AppFormSubmit"] = "APP_FORM_SUBMIT";
    InteractionEventType["AppSearch"] = "APP_SEARCH";
    InteractionEventType["AppExternalLink"] = "APP_EXTERNAL_LINK";
    InteractionEventType["UserSignUp"] = "USER_SIGN_UP";
    InteractionEventType["TrainingEpisodeView"] = "TRAINING_EPISODE_VIEW";
    InteractionEventType["TrainingEpisodeCompleted"] = "TRAINING_EPISODE_COMPLETED";
    InteractionEventType["TrainingPrizeWin"] = "TRAINING_PRIZE_WIN";
    InteractionEventType["TrainingSeasonCompleted"] = "TRAINING_SEASON_COMPLETED";
    InteractionEventType["TrainingCategoryCompleted"] = "TRAINING_CATEGORY_COMPLETED";
    InteractionEventType["PlatformAuthRequest"] = "PLATFORM_AUTH_REQUEST";
    InteractionEventType["CampaignEnrol"] = "CAMPAIGN_ENROL";
    InteractionEventType["Search"] = "SEARCH";
    InteractionEventType["AssetDownload"] = "ASSET_DOWNLOAD";
    InteractionEventType["AssetView"] = "ASSET_VIEW";
    InteractionEventType["AssetShare"] = "ASSET_SHARE";
    InteractionEventType["FeedItemView"] = "FEED_ITEM_VIEW";
    InteractionEventType["DealRegistration"] = "DEAL_REGISTRATION";
    InteractionEventType["OpportunityRegistration"] = "OPPORTUNITY_REGISTRATION";
    InteractionEventType["Referral"] = "REFERRAL";
    InteractionEventType["InstantWinRedeem"] = "INSTANT_WIN_REDEEM";
    InteractionEventType["InstantWinSuccess"] = "INSTANT_WIN_SUCCESS";
    InteractionEventType["InstantWinFail"] = "INSTANT_WIN_FAIL";
})(InteractionEventType = exports.InteractionEventType || (exports.InteractionEventType = {}));
var EmailSendStatusType;
(function (EmailSendStatusType) {
    EmailSendStatusType["Approved"] = "APPROVED";
})(EmailSendStatusType = exports.EmailSendStatusType || (exports.EmailSendStatusType = {}));
var AudienceType;
(function (AudienceType) {
    AudienceType["All"] = "ALL";
    AudienceType["User"] = "USER";
    AudienceType["Team"] = "TEAM";
    AudienceType["Campaign"] = "CAMPAIGN";
    AudienceType["Role"] = "ROLE";
})(AudienceType = exports.AudienceType || (exports.AudienceType = {}));
var RewardLevel;
(function (RewardLevel) {
    RewardLevel["None"] = "NONE";
    RewardLevel["One"] = "ONE";
    RewardLevel["Two"] = "TWO";
    RewardLevel["Three"] = "THREE";
})(RewardLevel = exports.RewardLevel || (exports.RewardLevel = {}));
var EntityPrequisiteType;
(function (EntityPrequisiteType) {
    EntityPrequisiteType["Interaction"] = "INTERACTION";
})(EntityPrequisiteType = exports.EntityPrequisiteType || (exports.EntityPrequisiteType = {}));
var EmailTemplateTypeEnum;
(function (EmailTemplateTypeEnum) {
    EmailTemplateTypeEnum["Default"] = "DEFAULT";
    EmailTemplateTypeEnum["PasswordReset"] = "PASSWORD_RESET";
    EmailTemplateTypeEnum["EmailConfirmation"] = "EMAIL_CONFIRMATION";
    EmailTemplateTypeEnum["Other"] = "OTHER";
    EmailTemplateTypeEnum["PasswordResetConfirm"] = "PASSWORD_RESET_CONFIRM";
    EmailTemplateTypeEnum["WebFormSubmitResult"] = "WEB_FORM_SUBMIT_RESULT";
})(EmailTemplateTypeEnum = exports.EmailTemplateTypeEnum || (exports.EmailTemplateTypeEnum = {}));
